import { hotList } from '@/mocks/comics';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-8">
          <div>
            <p className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-3">
              <i className="ri-bar-chart-2-fill"></i>
              热门排行
            </p>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              大家都在追
            </h2>
            <p className="mt-2 text-foreground-600 text-sm">按人气与评分综合排名的热门榜单，热度实时更新。</p>
          </div>
          <a href="#new" className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-500 whitespace-nowrap">
            查看新上架 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          {hotList.map((comic, i) => (
            <article
              key={comic.id}
              className="flex items-center gap-3 md:gap-4 p-3 rounded-2xl bg-background-50 border border-background-200 hover:border-accent-300 hover:shadow-sm transition-all"
            >
              <span
                className={`w-10 h-10 shrink-0 rounded-lg flex items-center justify-center font-heading text-lg ${
                  i < 3 ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-foreground-600'
                }`}
              >
                {i + 1}
              </span>
              <div className="w-14 md:w-16 shrink-0 aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
                <img src={comic.cover} alt={`${comic.title}漫画封面`} className="w-full h-full object-cover object-top" />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="font-medium text-foreground-950 text-sm md:text-base truncate">{comic.title}</h3>
                <p className="mt-0.5 text-xs text-foreground-600 truncate">{comic.category} · {comic.author}</p>
                <div className="mt-1.5 flex items-center gap-3 text-xs">
                  <span className="inline-flex items-center gap-1 text-accent-700">
                    <i className="ri-star-fill"></i>
                    {comic.rating}
                  </span>
                  <span className="inline-flex items-center gap-1 text-foreground-500">
                    <i className="ri-eye-line"></i>
                    {comic.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}